import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.93359 3.26676V1.26676C3.93359 0.900098 4.23359 0.600098 4.60026 0.600098H11.9336C12.3003 0.600098 12.6003 0.900098 12.6003 1.26676V10.6001C12.6003 10.9668 12.3003 11.2668 11.9336 11.2668H9.26693V3.93343C9.26693 3.56676 8.96693 3.26676 8.60026 3.26676H3.93359Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.59961 13.9335H1.26628C0.899609 13.9335 0.599609 13.6335 0.599609 13.2668V3.93351C0.599609 3.56685 0.899609 3.26685 1.26628 3.26685H8.59961C8.96628 3.26685 9.26628 3.56685 9.26628 3.93351V13.2668C9.26628 13.6335 8.96628 13.9335 8.59961 13.9335Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCopy;
